const baseUrl = '/api/customer/mediafeed'

export default {
    list: (opt) => {
        opt = {
            userId: null,
            mediaType: null,
            page_size: null,
            ...opt,
        }

        const toQs = ['userId', 'mediaType', 'page_size']
        const qs = toQs.filter(k => opt[k]).map(k => `${k}=${encodeURIComponent(opt[k])}`).join('&')

        return axios.get(`${baseUrl}${qs ? `?${qs}` : ''}`)
    },
}
